import { z } from 'zod';

export const zonesSchema = z.enum(['Avoid', 'Allow', 'WarnWhenDriving']);

export type Zones = z.infer<typeof zonesSchema>;
